import 'antd/dist/antd.less';
import { Typography, Input, Button, Space, Col } from 'antd';
import { GetById as getFiles } from './GetFiles/files';
import { GetById as getOd } from './GetFiles/od';
import { render } from 'react-dom';

const { Title, Text } = Typography;

const App = () => (
  <>
    <div id="title" style={{ display: 'flex', height: '50vh', justifyContent: 'center', flexWrap: 'wrap', flexDirection: 'column-reverse', alignItems: 'center' }}>
      <Title>TES286 文件下载页</Title>
    </div>
    <Space direction="vertical" size="large" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Input.Group compact>
        <Col span={24}>
          <Input placeholder="请输入文件id" style={{ width: 'calc(100% - 90px)' }} id='file-id' onKeyDown={(e) => {
            if (e.key === 'Enter') {
              document.getElementById('file-get').click();
            }
          }} />
          <Button type='primary' onClick={() => (parseFile(parseID(document.getElementById('file-id').value)))} id='file-get'>获取</Button>
        </Col>
      </Input.Group>
    </Space>
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div id='errorMsg' style={{ display: 'none' }}>
        <Text type='danger'>
          <b>错误:</b>
          <div id='errorMsgText'></div>
        </Text>
      </div>
      <div id="file-info" style={{ display: 'none' }}></div>
    </div>
  </>
);

const showError = (msg) => {
  msg = msg.replace(/\n/g, '<br />');
  msg = msg.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
  document.getElementById('errorMsg').style.display = 'block';
  document.getElementById('errorMsgText').innerHTML = msg;
}

const hiddenError = () => {
  document.getElementById('errorMsg').style.display = 'none';
}

const showFile = (dom) => {
  document.getElementById('file-info').style.display = 'block';
  render(dom, document.getElementById('file-info'));
  minTitle();
}

const hiddenFile = () => {
  document.getElementById('file-info').style.display = 'none';
}

const easeOutExpo = (x) => {
  return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}

const minTitle = () => {
  var dom = document.getElementById('title');
  const split_time = 10;
  const unit_proportion = 0.01;
  const max_height = 50; // vh
  const min_height = 10; // vh

  if (dom.style.height === min_height + 'vh') {
    return;
  }

  // Using easeOutExpo

  var progress = 0.0;
  var timer = setInterval(() => {
    progress += unit_proportion;
    if (progress > 1.0) {
      dom.style.height = min_height + 'vh';
      clearInterval(timer);
      return;
    }
    dom.style.height = max_height - (easeOutExpo(progress) * (max_height - min_height)) + 'vh';
  }, split_time);
}


const maxTitle = () => {
  var dom = document.getElementById('title');
  const split_time = 10;
  const unit_proportion = 0.01;
  const max_height = 50; // vh
  const min_height = 10; // vh

  if (dom.style.height === max_height + 'vh') {
    return;
  }

  // Using easeOutExpo

  var progress = 0.0;
  var timer = setInterval(() => {
    progress += unit_proportion;
    if (progress > 1.0) {
      dom.style.height = max_height + 'vh';
      clearInterval(timer);
      return;
    }
    dom.style.height = min_height + (easeOutExpo(progress) * (max_height - min_height)) + 'vh';
  }, split_time);
}


const parseID = (id) => {
  hiddenError();
  hiddenFile();
  if (!id) {
    showError('未输入文件id (ErrEmptyID)')
    return false;
  }

  // {type}:{value}
  const ID_FORMAT = /[0-9a-zA-Z]+:(.+)/;

  if (!ID_FORMAT.test(id)) {
    showError('文件id格式错误 (ErrInvalidID)');
    return false;
  }
  return {
    // {type, value}
    type: id.split(':')[0],
    value: id.split(':')[1]
  }
}

const parseFile = (id) => {
  if (id) {
    const type = id.type, value = id.value;
    switch (type) {
      case 'files':
        getFiles(value);
        break;
      case 'od':
        getOd(value);
        break;
      default:
        showError('未知文件类型 (ErrUnknownType)');
    }
  } else {
    return false;
  }
}

export default App;
export { parseID, parseFile, showError, hiddenError, showFile, hiddenFile, maxTitle, minTitle };
